import { dispatch, req } from "hf-rt";
import { HOST_URL } from "../constants";

const initialState = {
  cbu: "",
  quantity: 1,
  accessory: "",
  soldout: false
};

export default {
  name: "order",
  actions: {
    resetQuantity: () => dispatch({ type: "RESET_QUANTITY" }),
    substract: () => dispatch({ type: "SUBSTRACT" }),
    increment: () => dispatch({ type: "INCREMENT" }),
    sendEmail: async function (email) {
      dispatch({ type: "SEND_EMAIL" });
      const response = await fetch(`${HOST_URL}/sendEmail`, {
        credentials: "include",
        method: "GET",
        body: JSON.stringify({ email }),
        headers: {
          "content-type": "application/json"
        }
      });
      if (!response.ok) {
        window.logApiErrors(
          "r",
          "sendEmail",
          response.status,
          response.statusText
        );
      }
    }
  },

  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "RESET_QUANTITY":
        return { ...state, quantity: 1 };
      case "SUBSTRACT":
        return { ...state, quantity: state.quantity - 1 };
      case "INCREMENT":
        return { ...state, quantity: state.quantity + 1 };
      default:
        return state;
    }
  }
};
